import React from 'react';
import ReactDOM from 'react-dom';
import Portal from 'react-portal-to-body';

import { CookieNoticeBannerContainer } from './components';

/**
 * Render the cookie notice banner into the document body as soon as the window is ready.
 */
export default function render() {
    ReactDOM.render(
        <Portal><CookieNoticeBannerContainer /></Portal>, document.createElement('div')
    );
}
